
<div class="container body">
    <div class="main_container">
        <app-menu *ngIf="isLogin()==true"></app-menu>
        <router-outlet></router-outlet>
    </div>
</div>